import * as React from "react"
import Svg, { Path } from "react-native-svg"

function TransactionIconUnfocused(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <Path
        d="M6.5 2.75h7.56l.959 3.45a1.75 1.75 0 001.189 1.21l.116.03 3.426.76V20c0 .69-.56 1.25-1.25 1.25h-12c-.69 0-1.25-.56-1.25-1.25V4c0-.647.492-1.18 1.122-1.243L6.5 2.75z"
        stroke={props?.color??"#80838D"}
        strokeWidth={0.5}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.522 18.622a.503.503 0 00.418-.039.44.44 0 00.17-.2.426.426 0 00.034-.262.454.454 0 00-.13-.229l-2.826-2.948h.562a2.86 2.86 0 001.952-.726c.523-.46.812-1.074.875-1.828h.707a.445.445 0 00.454-.455.446.446 0 00-.454-.454h-.74a2.818 2.818 0 00-.676-1.235h1.416c.12 0 .231-.038.32-.12a.424.424 0 00.134-.321.446.446 0 00-.454-.455h-5.48a.446.446 0 00-.454.455c0 .124.042.236.134.322.089.081.2.119.32.119h1.946c.472 0 .883.136 1.24.406.302.23.505.505.614.829h-3.8a.446.446 0 00-.454.454.445.445 0 00.454.455h3.876c-.053.513-.256.902-.602 1.182a2.05 2.05 0 01-1.328.477h-1.125a.636.636 0 00-.463.19.636.636 0 00-.19.463c0 .092.02.186.057.279a.679.679 0 00.145.236l3.183 3.289a.35.35 0 00.165.116zm.471-.357a.338.338 0 01-.02.056c-.052.12-.15.179-.29.179a.354.354 0 01-.113-.02.202.202 0 01-.1-.073l-3.19-3.295a.532.532 0 01-.112-.185.622.622 0 000 0 .53.53 0 00.113.185l3.19 3.295c.026.036.06.06.099.073.04.014.077.02.112.02.141 0 .239-.06.291-.179a.342.342 0 00.02-.056zm-2.243-3.47h-.913.913a2.71 2.71 0 001.853-.69 2.376 2.376 0 000 .001 2.71 2.71 0 01-1.853.688zm2.687-2.555h.847-.847zm.847-2.144h-1.827 1.827a.31.31 0 010 0zM9.5 9.805c0 .088.029.158.086.211a.31.31 0 00.218.08h1.946c.503 0 .946.145 1.33.436.384.291.624.658.722 1.099a1.86 1.86 0 00-.721-1.098 2.14 2.14 0 00-1.331-.437H9.804a.31.31 0 01-.218-.08.274.274 0 01-.086-.211zm0 2.13c0 .088.029.161.086.219.057.057.13.086.218.086h4.037-4.037a.296.296 0 01-.218-.086.296.296 0 01-.086-.219z"
        fill={props?.color??"#80838D"}
      />
      <Path d="M14.25 6.5v-4L20 8h-4.25a1.5 1.5 0 01-1.5-1.5z" fill={props?.color??"#80838D"} />
    </Svg>
  )
}

export default TransactionIconUnfocused
